// Shared address formatting helpers for validation + autocomplete.

import type { StructuredAddress } from "./types.js";

export function formatStructuredAddressOneLine(a: StructuredAddress): string {
  const parts: string[] = [];
  if (a.street?.trim()) parts.push(a.street.trim());
  const cityStateZip = [a.city, a.state, a.postal_code]
    .map((v) => v?.trim())
    .filter(Boolean)
    .join(" ");
  if (cityStateZip) parts.push(cityStateZip);
  return parts.join(", ");
}

export function formatStructuredAddressMultiline(a: StructuredAddress): string {
  const line1 = a.street?.trim() ?? "";
  const cityState = [a.city?.trim(), a.state?.trim()].filter(Boolean).join(", ");
  const line2 = [cityState, a.postal_code?.trim()].filter(Boolean).join(" ");
  return [line1, line2].filter(Boolean).join("\n");
}

type GoogleAddressComponent = {
  longText?: string;
  shortText?: string;
  types?: string[];
};

/** Parse Google Places API (New) addressComponents into our shape. */
export function structuredAddressFromGoogleComponents(
  components: GoogleAddressComponent[] | undefined,
): StructuredAddress {
  const byType = (type: string) =>
    components?.find((c) => c.types?.includes(type));

  const streetNumber = byType("street_number")?.longText?.trim() ?? "";
  const route = byType("route")?.longText?.trim() ?? "";
  const street = [streetNumber, route].filter(Boolean).join(" ").trim();

  return {
    street: street || undefined,
    city:
      byType("locality")?.longText?.trim() ||
      byType("postal_town")?.longText?.trim() ||
      byType("sublocality")?.longText?.trim() ||
      undefined,
    state: byType("administrative_area_level_1")?.shortText?.trim() || undefined,
    postal_code: byType("postal_code")?.longText?.trim() || undefined,
  };
}
